import { CheckoutRequest, CheckoutResponse } from "../types/global";
import { fetchEnvironment } from "./authHandler";
import { devLog, devError } from "./devLog";

const CHECKOUT_SUFFIX = "/payment/checkout";

/**
 * Initiates a payment checkout session
 */
export const initiateCheckout = async (
  token: string,
  checkoutRequest: CheckoutRequest
): Promise<CheckoutResponse> => {
  try {
    // Fetch the correct backend environment URL based on app version
    const environmentPrefix = await fetchEnvironment();

    const response = await fetch(environmentPrefix + CHECKOUT_SUFFIX, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(checkoutRequest),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const checkoutData: CheckoutResponse = await response.json();
    devLog("[Payment] Checkout session created:", checkoutData);

    return checkoutData;
  } catch (error) {
    devError("[Payment] Checkout failed:", error);
    throw error;
  }
};
